import axios from 'axios'
import axiosRetry from 'axios-retry'
import i18next from 'i18next'

// Axios instance with retry logic for 404 errors
// Used for endpoints that may fail due to race conditions
export const retryOn404Instance = axios.create()

export const retryOn404 = (error) => error.response && error.response.status === 404

axiosRetry(retryOn404Instance, {
  retries: 3,
  retryDelay: () => 1000,
  retryCondition: retryOn404
})

const httpClient = {
  getWithRetryOn404: async (url, token, headers) => {
    headers = { 'Accept-Language': i18next.language, ...headers }
    if (token) {
      return retryOn404Instance
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            ...headers
          }
        })
        .then(response => response)
    }
    return retryOn404Instance
      .get(url, { headers })
      .then(response => response)
  },
  get: async (url, token, headers) => {
    headers = { 'Accept-Language': i18next.language, ...headers }
    if (token) {
      return axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            ...headers
          }
        })
        .then(response => response)
    }
    return axios
      .get(url, { headers })
      .then(response => response)
  },
  post: async (url, data, token, headers) => {
    headers = { 'Accept-Language': i18next.language, ...headers }
    if (token) {
      return axios
        .post(url, data, {
          headers: {
            Authorization: `Bearer ${token}`,
            ...headers
          }
        })
    }
    return axios
      .post(url, data, {
        headers: {
          ...headers
        }
      })
  }
}

export default httpClient
